import React, { useState, useContext, useEffect } from 'react';
import { Button } from 'reactstrap';

// import contexts
import { ThemeContext } from '../../contexts/ThemeContext';
import { AuthContext } from '../../contexts/AuthContext';

// import services

// local imports
import GeneralNavbar from '../general/GeneralNavbar';
import Footer from '../general/Footer';
import UserLandingScreenImg from '../../assets/userLandingScreen.svg';

const UserSignUpLandingScreen = props => {

    // contexts
    const { theme, colors } = useContext(ThemeContext);
    const { user, setUser } = useContext(AuthContext);

    // states

    // useEffects
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    // function's return
    return (
        <div>
            <GeneralNavbar history={props.history} />

            <div className="p-3 col-md-8 mt-5 offset-md-2 text-center">
                <h1 style={theme.headingXXL} id="signUp-landing-h1">Select what you seek on the Platform</h1>
                <h2 style={theme.headingRegular} id="signUp-landing-h2">You can add other roles later too</h2>
                <img className='mt-5' width="60%" src={UserLandingScreenImg} alt="user landing screen image" id="user-singUp-landing-img" />
            </div>

            <div className='row justify-content-around mt-5'>

                {
                    !user.roles.includes('client') ?
                        <div className='col-md-4 col-12 mb-5' id="signUp-landing-client-box">
                            <div className='d-flex flex-column p-3 mx-4' style={theme.card}>
                                <h3 className="text-center" style={theme.cardTitle} id="signUp-Client-heading">Client</h3>

                                <div className='mt-5 row' style={theme.cardParagraph}>
                                    <p className='col-md-2 col-2 text-center' style={{ color: colors.primary, fontSize: "1.2rem" }}>
                                        <i className="fas fa-check"></i>
                                    </p>
                                    <p className='col-md-10 col-10' id="signUp-client-p1">
                                        Get help from your choice of counsellor on the platform.
                                    </p>
                                </div>


                                <div className='row' style={theme.cardParagraph}>
                                    <p className='col-md-2 col-2 text-center' style={{ color: colors.primary, fontSize: "1.2rem" }}>
                                        <i className="fas fa-check"></i>
                                    </p>
                                    <p className='col-md-10 col-10' id="signUp-client-p2">
                                        Decide mode of live session from Chat, Call and Video.
                                    </p>
                                </div>

                                <div className='row' style={theme.cardParagraph}>
                                    <p className='col-md-2 col-2 text-center' style={{ color: colors.primary, fontSize: "1.2rem" }}>
                                        <i className="fas fa-check"></i>
                                    </p>
                                    <p className='col-md-10 col-10' id="signUp-client-p3">
                                        Chat with your counsellor anytime through Chat Subscriptions.
                                    </p>
                                </div>

                                <div className='mt-auto mx-auto mb-1'>
                                    <Button style={theme.buttonRounded} onClick={() => props.history.push('/client/landingScreen')} id="seek-counselling">Seek Counselling</Button>
                                </div>

                            </div>
                        </div>
                        : null
                }

                {
                    !user.roles.includes('provider') ?
                        <div className='col-md-4 col-12 mb-5' id="signUp-landing-counsellor-box">
                            <div className='d-flex flex-column p-3 mx-4' style={theme.card}>
                                <h3 className="text-center" style={theme.cardTitle} id="signUp-Counsellor-heading">Counsellor</h3>

                                <div className='mt-5 row' style={theme.cardParagraph}>
                                    <p className='col-md-2 col-2 text-center' style={{ color: colors.primary, fontSize: "1.2rem" }}>
                                        <i className="fas fa-check"></i>
                                    </p>
                                    <p className='col-md-10 col-10' id="signUp-counsellor-p1">
                                        Provide counselling services to clients.
                                    </p>
                                </div>


                                <div className='row' style={theme.cardParagraph}>
                                    <p className='col-md-2 col-2 text-center' style={{ color: colors.primary, fontSize: "1.2rem" }}>
                                        <i className="fas fa-check"></i>
                                    </p>
                                    <p className='col-md-10 col-10' id="signUp-counsellor-p2">
                                        Manage Pricing for your services.
                                    </p>
                                </div>

                                <div className='row' style={theme.cardParagraph}>
                                    <p className='col-md-2 col-2 text-center' style={{ color: colors.primary, fontSize: "1.2rem" }}>
                                        <i className="fas fa-check"></i>
                                    </p>
                                    <p className='col-md-10 col-10' id="signUp-counsellor-p3">
                                        Start for free. Pay as you Grow.
                                    </p>
                                </div>

                                <div className='row' style={theme.cardParagraph}>
                                    <p className='col-md-2 col-2 text-center' style={{ color: colors.primary, fontSize: "1.2rem" }}>
                                        <i className="fas fa-check"></i>
                                    </p>
                                    <p className='col-md-10 col-10' id="signUp-counsellor-p4">
                                        You keep all what you earn.
                                    </p>
                                </div>

                                <div className='mt-auto mx-auto mb-1'>
                                    <Button style={theme.buttonRounded} onClick={() => props.history.push('/counsellor/landingScreen')} id="become-counsellor">Become Counsellor</Button>
                                </div>

                            </div>
                        </div>
                        : null
                }
                {/* {
                    !user.roles.includes('organisation_admin') ?
                        <div className='col-md-4 col-12'>
                            <div className='d-flex flex-column p-3 mx-4' style={theme.card}>
                                <h3 className="text-center" style={theme.cardTitle}>Organisation</h3>

                                <div className='mt-5 row' style={theme.cardParagraph}>
                                    <p className='col-md-2 col-2 text-center' style={{ color: colors.primary, fontSize: "1.2rem" }}>
                                        <i className="fas fa-check"></i>
                                    </p>
                                    <p className='col-md-10 col-10'>
                                        Have Offline Setups? Bring your counsellors on the Platform
                                    </p>
                                </div>


                                <div className='row' style={theme.cardParagraph}>
                                    <p className='col-md-2 col-2 text-center' style={{ color: colors.primary, fontSize: "1.2rem" }}>
                                        <i className="fas fa-check"></i>
                                    </p>
                                    <p className='col-md-10 col-10'>
                                        Start for free. Pay as you Grow
                                    </p>
                                </div>

                                <div className='row' style={theme.cardParagraph}>
                                    <p className='col-md-2 col-2 text-center' style={{ color: colors.primary, fontSize: "1.2rem" }}>
                                        <i className="fas fa-check"></i>
                                    </p>
                                    <p className='col-md-10 col-10'>
                                        You keep all what you earn
                                    </p>
                                </div>

                                <div className='row' style={theme.cardParagraph}>
                                    <p className='col-md-2 col-2 text-center' style={{ color: colors.primary, fontSize: "1.2rem" }}>
                                        <i className="fas fa-check"></i>
                                    </p>
                                    <p className='col-md-10 col-10'>
                                        Pay your Counsellors according to your terms
                                    </p>
                                </div>

                                <div className='mt-auto mx-auto mb-1'>
                                    <Button style={theme.buttonRounded} onClick={() => props.history.push('/organisation/landingScreen')}>Create Organisation</Button>
                                </div>

                            </div>
                        </div>
                        : null
                } */}
            </div>


            <Footer />

        </div>
    )
}

export default UserSignUpLandingScreen;